/* Silvery Silver: the floating WhatsApp "Chat with us" button is shown on the homepage only (owner request,
   12 Oct 2026). layout/theme.liquid loads this file on every page except the homepage.
   The button is added by a WhatsApp app, so the app's own settings are not touched: this script only hides the
   app's floating widget on the page. Remove the script tag in theme.liquid to show the button everywhere again.

   What is hidden: an element that shows the text "Chat with us" or links to wa.me / api.whatsapp.com / wa.link
   (or whose id, class or src mentions whatsapp), and only when it sits in a position:fixed box that the app added
   outside the theme's own content and holds no form fields (so COD King and pop-up forms are never hidden).
   WhatsApp links inside the page content, header or footer (for example the product page "Share on WhatsApp"
   link or the contact page number) are never touched. */
(function () {
  'use strict';

  var LINK = /wa\.me|api\.whatsapp\.com|wa\.link|whatsapp|wacb/i;
  var THEME = 'main, header, footer, .shopify-section, [data-ss-sticky], #preview-bar-iframe';

  function attrs(el) {
    var cls = typeof el.className === 'string' ? el.className : el.getAttribute('class');
    return [el.id, cls, el.getAttribute('href'), el.getAttribute('src'), el.getAttribute('aria-label'), el.getAttribute('title')].join(' ');
  }
  function ownText(el) {
    var t = '';
    for (var i = 0; i < el.childNodes.length; i += 1) if (el.childNodes[i].nodeType === 3) t += el.childNodes[i].nodeValue;
    return t;
  }
  function isChat(el) {
    return LINK.test(attrs(el)) || /chat with us/i.test(ownText(el));
  }
  function up(n) { return n.parentNode && n.parentNode.nodeType === 11 ? n.parentNode.host : n.parentElement; }
  /* The outermost position:fixed box around the element (looking through open shadow roots) */
  function fixedBox(el) {
    var n = el;
    var box = null;
    while (n && n.nodeType === 1 && n !== document.body && n !== document.documentElement) {
      if (window.getComputedStyle(n).position === 'fixed') box = n;
      n = up(n);
    }
    return box;
  }
  /* The app's own container: the direct child of <body> holding the widget, when it is not part of the theme */
  function appRoot(box) {
    var n = box;
    while (up(n) && up(n) !== document.body) n = up(n);
    if (up(n) !== document.body) return box;
    if (n.matches(THEME) || n.querySelector('main, header, footer, .shopify-section, [data-ss-sticky]')) return box;
    return n;
  }
  function hide(el) {
    if (el.hasAttribute('data-ss-chat-hidden')) return;
    el.style.setProperty('display', 'none', 'important');
    el.setAttribute('data-ss-chat-hidden', '');
  }

  function scan(node) {
    var els = node.querySelectorAll('*');
    for (var i = 0; i < els.length; i += 1) {
      var el = els[i];
      if (el.shadowRoot) scan(el.shadowRoot);
      if (!isChat(el)) continue;
      if (el.closest && el.closest(THEME)) continue; /* theme content: never touched */
      var box = fixedBox(el);
      if (!box || (box.closest && box.closest(THEME))) continue;
      var target = appRoot(box);
      /* Safety: never hide anything holding a form (COD forms, pop-ups, cookie banners) */
      if (target.querySelector('form, input, select, textarea') || box.querySelector('form, input, select, textarea')) continue;
      hide(target);
    }
  }

  var queued = false;
  function run() {
    queued = false;
    try { scan(document.body); } catch (e) { /* never break the page */ }
  }
  function queue() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(run);
  }

  function start() {
    run();
    /* Apps add their widget after load: watch <body> for 30 seconds, then stop */
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(queue);
      mo.observe(document.body, { childList: true, subtree: true });
      window.setTimeout(function () { mo.disconnect(); run(); }, 30000);
    }
    window.addEventListener('load', run);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
